import React from 'react';
import FieldCreditCard from '../fields/FieldCreditCard';
import FieldSelect from '../fields/FieldSelect';
import FieldCheckbox from '../fields/FieldCheckbox';
import AddressFormFields from '../common/AddressFormFields';
import CreditCardFormFields from '../common/NewCreditCardFormFields';
import { getTranslation } from '../../lang/main';
import {getFieldStatusProps} from "../../selectors/defaultSelectors";
import Field from "../Checkout/CheckoutPurchaseOrderNumber";
import LocalizedMessage from "react-l10n";

const FORM_LABEL = {
    CreditCardID: getTranslation('FIELD.SELECT_CARD'),
    Cvv: getTranslation('FIELD.CVV'),
    SaveCard: getTranslation('FIELD.SAVE_CARD'),
};

function PaymentMethodFormCreditCardTab(props) {
    const {
        fieldRefs,
        fieldStatus,
        formData,
        updateFormData,
        handleFormUpdate,
        handleFormUpdateNumber,
        creditCardList,
    } = props;

    const hasExistingCards = creditCardList && creditCardList.length > 0;
    const cardImage =
        typeof window.defaultImages.cards != 'undefined'
            ? window.defaultImages.cards
            : '';

    const canUseSavedCard =
        typeof props.canUseSavedCard != 'undefined'
            ? props.canUseSavedCard
            : true;
    const showCreditCardBillingAddressFields =
        typeof props.showCreditCardBillingAddressFields != 'undefined'
            ? props.showCreditCardBillingAddressFields
            : true;

    const showAddNewCard =
        formData.CreditCardID == 'add-new-card' || !hasExistingCards || false;

    /**
     * Get list of credit cards
     *
     * @return array
     **/
    const getCreditCardDropdown = () => {
        let creditCardDropdown = [
            {
                label: getTranslation('FIELD.SELECT_CARD'),
                value: '',
            },
        ];

        if (creditCardList.length) {
            creditCardDropdown = [
                ...creditCardDropdown,
                ...creditCardList.map((item) => {
                    return {
                        label: `${item.CardName} - ${item.Title}`,
                        value: item.ID,
                    };
                }),
            ];
        }

        if (canUseSavedCard) {
            // Add "Add new card" to dropdown
            creditCardDropdown.push({
                label: getTranslation('ADD_NEW_CREDIT_CARD'),
                value: 'add-new-card',
            });
        }

        return creditCardDropdown;
    };

    const newCreditCardFormFields = (
        <CreditCardFormFields
            {...props}
            required={formData.PaymentMethod == 'stripe' && (formData.CreditCardID == 0 || formData.CreditCardID == 'add-new-card')}
        />
    );

    return (
        <React.Fragment>
            <div className='form credit-card-form'>
                <div className='all-options'>
                    {hasExistingCards === true && canUseSavedCard === true && (
                        <React.Fragment>
                            <FieldSelect
                                ref={(r) => (fieldRefs.CreditCardID = r)}
                                required={formData.PaymentMethod == 'stripe'}
                                label={FORM_LABEL['CreditCardID']}
                                animatedLabel={FORM_LABEL['CreditCardID']}
                                name='CreditCardID'
                                options={getCreditCardDropdown()}
                                value={formData.CreditCardID}
                                onChange={handleFormUpdate}
                                {...getFieldStatusProps(fieldStatus, 'CreditCardID')}
                            />
                        </React.Fragment>
                    )}

                    <div
                        id='new-card'
                        className={`collapse ${showAddNewCard === true &&
                            'in'}`}
                    >
                        {newCreditCardFormFields}

                        {canUseSavedCard === true && (
                            <div className='form__highlight form__highlight--small'>
                                <FieldCheckbox
                                    ref={(r) => (fieldRefs.SaveCard = r)}
                                    checked={formData.SaveCard == 1}
                                    label={FORM_LABEL['SaveCard']}
                                    name='SaveCard'
                                    value={formData.SaveCard == 1 ? 0 : 1}
                                    onChange={handleFormUpdateNumber}
                                />
                            </div>
                        )}
                    </div>
                </div>

                {cardImage != '' && (
                    <div className='photo photo--right vspace'>
                        <img src={cardImage} width='80' />
                    </div>
                )}

                {showCreditCardBillingAddressFields === true && (
                    <React.Fragment>
                        {/* Credit Card Payment Address */}
                        <div className='form new-address-form' data-action='#'>
                            <div className='form__highlight form__highlight--small'>
                                <h5 className='heading--lv5 heading'>
                                    <LocalizedMessage id={'BILLING_ADDRESS'} />
                                </h5>
                                <div
                                    className={`vspace vspace--small collapse ${
                                        formData.UseNewBillingAddress != 1
                                            ? 'in'
                                            : ''
                                    }`}
                                >
                                    <div className='text-box text-box--small text-box--grey'>
                                        <p>
                                            <b>McDonalds Farms</b>
                                            <br />
                                            116 St Kilda Road,
                                            <br />
                                            St Kilda,
                                            <br />
                                            3182,
                                            <br />
                                            Victoria
                                        </p>
                                    </div>
                                </div>

                                <FieldCheckbox
                                    ref={(r) =>
                                        (fieldRefs.UseNewBillingAddress = r)
                                    }
                                    checked={formData.UseNewBillingAddress == 1}
                                    label='Use New Address'
                                    name='UseNewBillingAddress'
                                    value={
                                        formData.UseNewBillingAddress == 1
                                            ? 0
                                            : 1
                                    }
                                    onChange={handleFormUpdateNumber}
                                />

                                <div
                                    className={`new-address collapse ${
                                        formData.UseNewBillingAddress == 1
                                            ? 'in'
                                            : ''
                                    }`}
                                >
                                    <AddressFormFields
                                        fieldRefs={fieldRefs}
                                        formData={formData}
                                        updateField={updateFormData}
                                        onFieldUpdate={handleFormUpdate}
                                    />
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                )}
            </div>
        </React.Fragment>
    );
}

export default PaymentMethodFormCreditCardTab;
